import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCrowdAddBadgesRequestBody,
  IApiCrowdAddBadgesResponseBody,
} from '../CrowdApi.types';
import { useApi } from '~/lib/api/useApi';
import { userBadgesQueryKeyFactory } from '../../UserBadges/hooks/useUserBadgesQuery';

export type IUseAddBadgesCrowdMutationValues = {
  appId: string;
  body: IApiCrowdAddBadgesRequestBody;
};

export const useAddBadgesCrowdMutation = (): UseMutationResult<
  IApiCrowdAddBadgesResponseBody,
  unknown,
  IUseAddBadgesCrowdMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.crowd.addBadges(values.appId, values.body),
    onSuccess: async (_data, values) => {
      await queryClient.invalidateQueries({
        queryKey: userBadgesQueryKeyFactory({ appId: values.appId }),
      });
    },
  });
};
